import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { WEBSITE_FAQS } from './websiteData';

export default function WebsiteFaqPage() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="dgw-page-wrap">

      {/* Hero */}
      <section className="dgw-hero" style={{textAlign:'center'}}>
        <div className="dgw-hero-inner" style={{maxWidth:760}}>
          <div className="dgw-badge">
            <span className="dgw-badge-dot" />
            FAQ
          </div>
          <h1>The answers engineers<br/>actually want.</h1>
          <p className="dgw-hero-lead" style={{maxWidth:560, margin:'0 auto 40px'}}>
            Specific questions about DepGuard, Vigil, and PRISM. Answered precisely,
            without the sales layer.
          </p>
        </div>
      </section>

      {/* FAQ accordion */}
      <section className="dgw-section" style={{background:'#fff'}}>
        <div style={{maxWidth:760, margin:'0 auto'}}>
          <div style={{display:'flex', flexDirection:'column', gap:2}}>
            {WEBSITE_FAQS.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.q} style={{
                  borderRadius: 12,
                  border: `1px solid ${open ? 'rgba(99,102,241,.3)' : '#e2e8f0'}`,
                  background: open ? 'rgba(99,102,241,.02)' : '#fff',
                  overflow: 'hidden',
                  transition: 'all .2s',
                }}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    style={{
                      width:'100%', display:'flex', alignItems:'center',
                      justifyContent:'space-between', gap:16,
                      padding:'20px 24px', background:'none', border:'none',
                      cursor:'pointer', textAlign:'left',
                    }}
                  >
                    <span style={{fontSize:16, fontWeight:600, color:'#0f172a', lineHeight:1.4}}>{item.q}</span>
                    <span style={{
                      fontSize:20, color: open ? '#6366f1' : '#94a3b8',
                      flexShrink:0, transition:'transform .2s',
                      transform: open ? 'rotate(45deg)' : 'none',
                    }}>+</span>
                  </button>
                  {open && (
                    <p style={{
                      padding:'0 24px 20px', margin:0,
                      fontSize:15, color:'#475569', lineHeight:1.7,
                    }}>{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Still have questions CTA */}
      <section className="dgw-section" style={{background:'#f8fafc'}}>
        <div style={{maxWidth:640, margin:'0 auto', textAlign:'center'}}>
          <h2 style={{fontSize:'clamp(22px,3vw,32px)', fontWeight:800, color:'#0f172a', marginBottom:12}}>
            Didn't find what you need?
          </h2>
          <p style={{fontSize:16, color:'#475569', marginBottom:32}}>
            Drop us a line. We respond within one business day. If you're evaluating
            for enterprise deployment, we'll set up a direct technical walkthrough.
          </p>
          <div style={{display:'flex', gap:12, justifyContent:'center', flexWrap:'wrap'}}>
            <Link to="/website/contact" className="dgw-btn dgw-btn-primary">Get in touch →</Link>
            <Link to="/website/whitepaper" className="dgw-btn dgw-btn-ghost">Read the whitepaper</Link>
          </div>
        </div>
      </section>

    </div>
  );
}

